export const postcodeConstants = {
    GET_CUSTOMER_POSTCODE_ALL: 'GET_CUSTOMER_POSTCODE_ALL',
    GET_CUSTOMER_POSTCODE_ALL_SUCCESS: 'GET_CUSTOMER_POSTCODE_ALL_SUCCESS',
    GET_CUSTOMER_POSTCODE_ALL_NODATA: 'GET_CUSTOMER_POSTCODE_ALL_NODATA',
    GET_CUSTOMER_POSTCODE_ALL_FAILURE: 'GET_CUSTOMER_POSTCODE_ALL_FAILURE',

    
};
